<template>
    <div>
        <div class="main-content">
            <div class="row">
                <div class="col-md-12">
                    <!-- Header da reserva -->
                    <div class="reservation-header-page">
                        <div class="row">
                            <div class="col-md-6">
                                <ImageVehicle
                                    v-if="reserve.vehicles"
                                    :vehicle-data="reserve.vehicles"
                                    :reserve-data="reserve"
                                />
                            </div>
                            <div class="col-md-6">
                                <div class="main-info-section h-100">
                                    <div class="status-row">
                                        <span
                                            class="status-badge"
                                            :class="getStatusClass(reserve.reserve_status)"
                                        >
                                            <i class="fas fa-info-circle"></i>
                                            {{ reserve.reserve_status ? reserve.reserve_status.title : 'N/A' }}
                                        </span>
                                        <div class="reservation-number">
                                            #{{ reserve.id }}
                                        </div>
                                    </div>

                                    <div class="vehicle-quick-info">
                                        <h5 v-if="reserve.vehicles">
                                            {{ getVehicleDescription() }}
                                        </h5>
                                        <div class="plate-container" v-if="reserve.vehicles">
                                            <i class="fas fa-hashtag"></i>
                                            {{ getVehicleBoard() }}
                                        </div>
                                    </div>

                                    <div class="user-info-compact">
                                        <span class="user-name">
                                            <i class="fas fa-user"></i>
                                            {{ reserve.user ? reserve.user.name : 'N/A' }}
                                        </span>
                                    </div>

                                    <div class="quick-dates">
                                        <div class="date-item">
                                            <i class="fas fa-calendar-alt"></i>
                                            <span>Retirada: {{ reserve.retreat_date }}</span>
                                        </div>
                                        <div class="date-item">
                                            <i class="fas fa-calendar-times"></i>
                                            <span>Devolução: {{ reserve.devolution_date }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Navegação por abas -->
                    <div class="card mt-4">
                        <div class="card-body p-0">
                            <div class="tab-navigation-container">
                                <ul class="nav nav-tabs nav-fill tab-navigation">
                                    <li class="nav-item">
                                        <div
                                            class="nav-link"
                                            :class="{ active: selectedMenu === 'reserve_data' }"
                                            @click="selectedMenu = 'reserve_data'"
                                        >
                                            <i class="fas fa-calendar-check mr-2"></i>
                                            Dados da Reserva
                                        </div>
                                    </li>
                                    <li class="nav-item">
                                        <div
                                            class="nav-link"
                                            :class="{ active: selectedMenu === 'vehicle_data' }"
                                            @click="selectedMenu = 'vehicle_data'"
                                        >
                                            <i class="fas fa-car mr-2"></i>
                                            Dados do Veículo
                                        </div>
                                    </li>
                                    <li class="nav-item">
                                        <div
                                            class="nav-link"
                                            :class="{ active: selectedMenu === 'historic_reserve' }"
                                            @click="selectedMenu = 'historic_reserve'"
                                        >
                                            <i class="fas fa-history mr-2"></i>
                                            Histórico da Reserva
                                        </div>
                                    </li>
                                    <li class="nav-item">
                                        <div
                                            class="nav-link"
                                            :class="{ active: selectedMenu === 'integrations' }"
                                            @click="selectedMenu = 'integrations'"
                                        >
                                            <i class="fas fa-exchange-alt mr-2"></i>
                                            Integrações
                                        </div>
                                    </li>
                                    <li class="nav-item">
                                        <div
                                            class="nav-link"
                                            :class="{ active: selectedMenu === 'messages' }"
                                            @click="selectedMenu = 'messages'"
                                        >
                                            <i class="fas fa-comments mr-2"></i>
                                            Mensagens
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="tab-content-container">
                                <ViewDataReserve
                                    v-show="selectedMenu === 'reserve_data'"
                                    :reserve="reserve"
                                    @open-checklist="showChecklistModal = true"
                                />

                                <ViewDataVehicle
                                    v-show="selectedMenu === 'vehicle_data'"
                                    :reserve="reserve"
                                />

                                <ViewHistoricReserve
                                    v-show="selectedMenu === 'historic_reserve'"
                                />

                                <ViewIntegrations
                                    v-show="selectedMenu === 'integrations'"
                                    :reserve="reserve"
                                    ref="viewIntegrations"
                                    @integration-updated="handleIntegrationUpdated"
                                />

                                <ViewMessages
                                    v-show="selectedMenu === 'messages'"
                                    :reserve="reserve"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Checklist -->
        <ViewModalCheckIn
            :modal-status="showChecklistModal"
            :reserve="reserve"
            @close="showChecklistModal = false"
            @open-lightbox="handleOpenLightbox"
        />

        <!-- Lightbox para fotos -->
        <vue-easy-lightbox
            :visible="visible"
            :imgs="imgs"
            @hide="handleHide"
        />

        <loading :active.sync="isLoading" :is-full-page="true" />
    </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import ViewDataReserve from "./view-components/ViewDataReserve.vue";
import ViewDataVehicle from "./view-components/ViewDataVehicle.vue";
import ViewMessages from "./view-components/ViewMessages.vue";
import ViewHistoricReserve from "./view-components/ViewHistoricReserve.vue";
import ViewIntegrations from "./view-components/ViewIntegrations.vue";
import ViewModalCheckIn from "./view-components/ViewModalCheckIn.vue";
import ImageVehicle from "../Modals/Components/ImageVehicle.vue";
import Loading from "vue-loading-overlay";
import {shouldHideVehicleData} from "../../composables/useVehicleVisibility";

export default {
    components: {
        Loading,
        VueEasyLightbox,
        ViewDataReserve,
        ViewDataVehicle,
        ViewMessages,
        ViewHistoricReserve,
        ViewIntegrations,
        ViewModalCheckIn,
        ImageVehicle
    },
    data() {
        return {
            imgs: "",
            visible: false,
            isLoading: false,
            showChecklistModal: false,
            selectedMenu: 'reserve_data',
            reserve: {
                user: {
                    name: "",
                },
                branch: {
                    description: "",
                },
                vehicle_type_id: {
                    description: "",
                },
                reserve_status: {
                    title: "",
                },
                vehicles: {
                    description: "",
                    board: "",
                },
            },
        };
    },
    methods: {
        getVehicleDescription() {
            const user = this.$store.state.user;
            if (shouldHideVehicleData(user, this.reserve)) {
                return 'Veículo Oculto';
            }
            return this.reserve.vehicles ? this.reserve.vehicles.description : 'N/A';
        },
        getVehicleBoard() {
            const user = this.$store.state.user;
            if (shouldHideVehicleData(user, this.reserve)) {
                return '***-***';
            }
            return this.reserve.vehicles ? this.reserve.vehicles.board : 'N/A';
        },
        show() {
            this.visible = true;
        },
        handleHide() {
            this.visible = false;
        },
        handleOpenLightbox(imgs) {
            this.imgs = imgs;
            this.show();
        },
        getStatusClass(status) {
            if (!status) return 'status-unknown';

            const statusClasses = {
                1: 'status-pending',
                2: 'status-approved',
                3: 'status-canceled',
                4: 'status-progress',
                5: 'status-completed'
            };
            return statusClasses[status.id] || 'status-unknown';
        },
        getReserve() {
            let self = this;
            let id = self.$route.params.id;
            self.isLoading = true;
            let api = self.$store.state.api + "reserveVehicles/" + id +
                "?with[]=user&with[]=branch&with[]=vehicle_type_id&with[]=reserve_status&with[]=vehicles&with[]=checkout&with[]=checkin&with[]=justification&with[]=cityDestination.city_destination&with[]=driver&with[]=ride&with[]=ride.requester";

            self.$http
                .get(api)
                .then((response) => {
                    self.reserve = response.data;
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, self.errors, "error");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        handleIntegrationUpdated(data) {
            console.log('Integração atualizada:', data);
        }
    },
    watch: {
        '$route'(to, from) {
            if (to.params.id !== from.params.id) {
                this.getReserve();
            }
        },
        selectedMenu(newMenu, oldMenu) {
            if (newMenu === 'integrations' && this.$refs.viewIntegrations) {
                this.$nextTick(() => {
                    this.$refs.viewIntegrations.reload();
                });
            }
        }
    },
    mounted() {
        $(".modal-backdrop.fade.show").remove();
        $("body").css("overflow", "scroll");
        this.getReserve();
    },
};
</script>

<style scoped>
/* Header da página de reserva */
.reservation-header-page {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.main-info-section {
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: 100%;
}

.status-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.status-badge {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.reservation-number {
    font-size: 24px;
    font-weight: bold;
    color: #6c757d;
}

.vehicle-quick-info h5 {
    margin: 0 0 10px 0;
    color: #495057;
    font-size: 18px;
    font-weight: 600;
}

.plate-container {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background-color: #f8981d;
    color: white;
    padding: 6px 12px;
    border-radius: 6px;
    font-weight: bold;
    font-size: 14px;
}

.user-info-compact {
    display: flex;
    align-items: center;
    gap: 10px;
}

.user-name {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    color: #495057;
    font-size: 16px;
}

.quick-dates {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.date-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #6c757d;
}

.date-item i {
    color: #f8981d;
    width: 16px;
}

/* Navegação das abas */
.tab-navigation-container {
    border-bottom: 1px solid #e2e8f0;
}

.tab-navigation {
    border-bottom: none;
    margin-bottom: 0;
}

.tab-navigation .nav-link {
    color: #6c757d;
    font-weight: 500;
    border: none;
    border-bottom: 3px solid transparent;
    border-radius: 0;
    padding: 15px 20px;
    transition: all 0.3s ease;
}

.tab-navigation .nav-link:hover {
    color: #f8981d;
    border-bottom-color: rgba(248, 152, 29, 0.3);
    background-color: rgba(248, 152, 29, 0.05);
}

.tab-navigation .nav-link.active {
    color: #f8981d;
    background-color: rgba(248, 152, 29, 0.1);
    border-bottom-color: #f8981d;
    font-weight: 600;
}

.tab-content-container {
    padding: 0;
}

/* Classes de status */
.status-pending {
    background-color: #8B00C7;
    color: #ffffff;
}

.status-approved {
    background-color: #FE8D18;
    color: #ffffff;
}

.status-canceled {
    background-color: #DC3545;
    color: #ffffff;
}

.status-progress {
    background-color: #FFA500;
    color: #ffffff;
}

.status-completed {
    background-color: #000000;
    color: #ffffff;
}

.status-unknown {
    background-color: #6c757d;
    color: #ffffff;
}

/* Responsividade */
@media (max-width: 768px) {
    .reservation-header-page {
        padding: 15px;
    }

    .status-row {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }

    .reservation-number {
        font-size: 20px;
    }

    .tab-navigation .nav-link {
        padding: 12px 15px;
        font-size: 14px;
    }

    .quick-dates {
        margin-top: 10px;
    }
}

@media (max-width: 576px) {
    .vehicle-quick-info h5 {
        font-size: 16px;
    }

    .user-name {
        font-size: 14px;
    }

    .date-item {
        font-size: 13px;
    }

    /* Responsividade das abas para dispositivos móveis */
    .tab-navigation {
        flex-wrap: wrap;
    }

    .tab-navigation .nav-item {
        flex: 1 1 50%; /* Duas abas por linha em mobile */
        min-width: 50%;
    }

    .tab-navigation .nav-link {
        padding: 10px 8px;
        font-size: 12px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/View.vue